import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./ProjectList.css";
import { ProjectInfo } from "./types";

function ProjectList(props: {}) {
  const [projects, setProjects] = useState<ProjectInfo[]>([]);

  useEffect(() => {
    fetch("/api/get-project-list", {
      method: "GET",
    })
      .then((response) => {
        console.log(response);
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then((data) => {
        setProjects(data.projects);
      })
      .catch((error) => {
        console.log(error);
        if (+error.status === 403) {
          console.log("unauthorized");
          //props.setLoggedIn(false);
        }
      });
  }, [props]);
  let projectList = <div>Loading projects...</div>;
  if (Array.isArray(projects)) {
    let projectDivs = [];
    for (let i = 0; i < 1; ++i) {
      for (let p of projects) {
        projectDivs.push(
          <NavLink to={"/projects/" + p.slug} className={"project-tile-wrap"} key={"link-" + p.slug}>
            <div className={"project-tile visibility-" + p.visibility} key={"link-" + p.project_name}>
              <img src={"./gameBox/" + p.slug + ".jpg"} alt={"box of " + p.project_name}></img>
              <h3>{p.project_name}</h3>
            </div>
          </NavLink>,
        );
      }
    }
    projectList = <div className="project-list">{projectDivs}</div>;
  }
  return (
    <nav>
      <h2>Select a game</h2>
      {projectList}
    </nav>
  );
}

export default ProjectList;
